import { cx } from '@linaria/core';
import { TransitionGroup } from 'react-transition-group';
import { CSSRefTransition } from '@utils/react';
import { useOpgavekompleksetComponent } from '../../state/context.data.js';
import { wrapper, progress, transitionDurationMs, dimmed } from './atom.progress.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function Progress(props) {
  const component = useOpgavekompleksetComponent();
  return /*#__PURE__*/jsx(TransitionGroup, {
    className: wrapper,
    children: /*#__PURE__*/jsx(CSSRefTransition, {
      timeout: transitionDurationMs,
      classNames: progress,
      children: ref => /*#__PURE__*/jsx("div", {
        ref: ref,
        className: cx(progress, props.dimmed && dimmed),
        children: /*#__PURE__*/jsxs("span", {
          children: [props.taskIndex + 1, " ", /*#__PURE__*/jsxs("span", {
            className: dimmed,
            children: ["/ ", component.data.tasks.length]
          })]
        })
      })
    }, props.taskIndex)
  });
}

export { Progress };
//# sourceMappingURL=atom.progress.js.map
